import { render } from "./FooterSelectors.vue?vue&type=template&id=373a32cc"
import script from "./FooterSelectors.vue?vue&type=script&lang=js"
export * from "./FooterSelectors.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__